import fareCondititionsModal from './eurail-fare-conditions-modal.html';
import {SIZE_LARGE} from '../../common/modal/modal-service';

export default function EuRailFareConditionsModal() {
    return {
        restrict: 'A',
        controller: EuRailFareConditionsModalController,
        controllerAs: 'euRailFareConditionsModalCtrl',
        link: function($scope, $elem, $attrs, euRailFareConditionsModalCtrl) {
            $elem.on('click', () => {
                const fares = $attrs.ktEuRailFareConditionsModalFares && $scope.$eval($attrs.ktEuRailFareConditionsModalFares) || null;

                euRailFareConditionsModalCtrl.openEuRailFareConditionsModal(fares);
            });
        },
    };
}

export function EuRailFareConditionsModalController(
    $scope,
    modalService,
    euRailFareConditionsModalService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        openEuRailFareConditionsModal,
    });

    function $onInit() {
    }

    function openEuRailFareConditionsModal(fares) {
        euRailFareConditionsModalService.getFareTypes(fares.map((fare) => fare.FareTypeId))
            .then((fareTypes) => {
                $scope.fareTypes = fareTypes;
                modalService.openModal({
                    template: fareCondititionsModal,
                    scope: $scope,
                    size: SIZE_LARGE,
                });
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/eurail-fare-conditions-modal/eurail-fare-conditions-modal-component.js